import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Card,
  CardContent,
  CardActions,
  Typography,
  Button,
  IconButton,
  Box
} from '@mui/material';
import {
  Edit as EditIcon,
  Close as CloseIcon,
  School as SchoolIcon,
  Refresh as RefreshIcon,
  Quiz as QuizIcon
} from '@mui/icons-material';
import DeckImage from './DeckImage';

function DeckCard({ deck, onDelete }) {
  const navigate = useNavigate();

  const cardsToReview = deck.cards.filter(
    card => !card.nextReview || new Date(card.nextReview).setHours(0, 0, 0, 0) <= new Date().setHours(0, 0, 0, 0)
  );

  return (
    <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column', position: 'relative' }}>
      <IconButton
        size="small"
        color="error"
        onClick={() => onDelete(deck.id)}
        title="Supprimer"
        sx={{
          position: 'absolute',
          top: 8,
          right: 8,
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
          }
        }}
      >
        <CloseIcon />
      </IconButton>
      
      <DeckImage imageUrl={deck.imageUrl} name={deck.name} />
      <CardContent sx={{ flexGrow: 1 }}>
        <Typography variant="h6" gutterBottom>
          {deck.name}
        </Typography>
        <Typography variant="body2" color="text.secondary" paragraph>
          {deck.description}
        </Typography>
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
          <Typography variant="body2" color="text.secondary">
            {deck.cards.length} carte{deck.cards.length > 1 ? 's' : ''}
          </Typography>
          {cardsToReview.length > 0 && (
            <Typography variant="body2" color="primary">
              • {cardsToReview.length} à étudier
            </Typography>
          )}
        </Box>
      </CardContent>
      <CardActions sx={{ p: 2, pt: 0, display: 'flex', gap: 1, justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button
            size="small"
            startIcon={<SchoolIcon />}
            onClick={() => navigate(`/study/${deck.id}`)}
            disabled={deck.cards.length === 0}
            title={deck.cards.length === 0 ? "Ajoutez des cartes pour étudier" : ""}
          >
            Étudier
          </Button>
          <Button 
            size="small"
            startIcon={<RefreshIcon />}
            onClick={() => navigate(`/study/${deck.id}?forceReview=true`)}
            disabled={deck.cards.length === 0}
            title={deck.cards.length === 0 ? "Ajoutez des cartes pour réviser" : ""}
          >
            Réviser
          </Button>
          <Button 
            size="small"
            startIcon={<QuizIcon />}
            onClick={() => navigate(`/quiz/${deck.id}`)}
            disabled={deck.cards.length < 4}
            title={deck.cards.length < 4 ? "Il faut au moins 4 cartes pour le quiz" : ""}
          >
            Quiz
          </Button>
        </Box>

        <IconButton
          size="small"
          onClick={() => navigate(`/decks/${deck.id}/edit`)}
          title="Modifier"
        >
          <EditIcon />
        </IconButton>
      </CardActions>
    </Card>
  );
}

export default DeckCard; 